<script>
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    isPercent: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    const isPercent = this.isPercent;
    const stacked = this.stacked;

    const internalOptions = {
      responsive: true,
      maintainAspectRatio: false,
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return isPercent ? value + "%" : value;
          },
        },
      },
      
      scales: {
        xAxes: [
          {
            ticks: {
              callback: function (value) {
                return value.length > 16 ? value.slice(0, 16) + "..." : value;
              },
            },
            stacked: stacked,
          },
        ],
        yAxes: [
          {
            max: isPercent ? 100 : undefined,
            beginAtZero: true,
            ticks: {
              callback: function (value) {
                return isPercent ? value + "%" : value;
              },
            },
            stacked: stacked,
          },
        ],
      },
    };

    this.renderChart(this.chartData, internalOptions);
  },
};
</script>
